import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  news: NewsItem;
  variant?: "vertical" | "horizontal" | "compact";
}

export default function NewsCard({ news, variant = "vertical" }: NewsCardProps) {
  if (variant === "compact") {
    return (
      <Link
        to={`/news/${news.id}`}
        className="group flex items-start gap-3 py-3 border-b border-background-200 last:border-0 cursor-pointer"
      >
        <span className="w-6 h-6 shrink-0 rounded bg-background-100 text-foreground-600 text-xs font-label flex items-center justify-center mt-0.5">
          <i className="ri-article-line"></i>
        </span>
        <div className="min-w-0">
          <h4 className="text-sm font-medium text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
            {news.title}
          </h4>
          <span className="mt-1 inline-block text-xs text-foreground-400 font-label">{news.publishTime}</span>
        </div>
      </Link>
    );
  }

  if (variant === "horizontal") {
    return (
      <Link
        to={`/news/${news.id}`}
        className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 overflow-hidden transition-colors cursor-pointer"
      >
        <div className="w-full sm:w-56 h-44 sm:h-auto shrink-0 overflow-hidden bg-background-100">
          <img
            src={news.image}
            alt={news.title}
            title={`${news.title} - NBA直播吧新闻`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex-1 p-4 flex flex-col">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-800 font-label">{news.category}</span>
            <span className="text-xs text-foreground-400 font-label">{news.publishTime}</span>
          </div>
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
            {news.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{news.summary}</p>
          <div className="mt-auto pt-3 flex items-center gap-2 text-xs text-foreground-400 font-label">
            <i className="ri-user-line"></i> {news.author}
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${news.id}`}
      className="group flex flex-col bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 overflow-hidden transition-colors cursor-pointer"
    >
      <div className="w-full h-44 overflow-hidden bg-background-100">
        <img
          src={news.image}
          alt={news.title}
          title={`${news.title} - NBA直播吧新闻`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-800 font-label">{news.category}</span>
          <span className="text-xs text-foreground-400 font-label">{news.publishTime}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
          {news.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{news.summary}</p>
        <div className="mt-auto pt-3 flex items-center gap-2 text-xs text-foreground-400 font-label">
          <i className="ri-user-line"></i> {news.author}
        </div>
      </div>
    </Link>
  );
}